import { SVGAttributes } from 'react';

export interface LogoProps extends SVGAttributes<SVGSVGElement> {
  size?: number;
}

export const Logo = ({
  size,
  width = size,
  height = size,
  ...props
}: LogoProps) => {
  return (
    <svg
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      {...props}
    >
      <rect width="400" height="400" rx="32" fill="#FFCC00" />
      <path
        d="M262 224H306V268C306 279.046 297.046 288 286 288H282C270.954 288 262 279.046 262 268V224Z"
        fill="#23221F"
      />
      <path
        d="M220 132C220 120.954 228.954 112 240 112H244C255.046 112 264 120.954 264 132V176H220V132Z"
        fill="#23221F"
      />
      <path
        d="M304 132C304 120.954 312.954 112 324 112H328C339.046 112 348 120.954 348 132V176H304V132Z"
        fill="#23221F"
      />
      <path
        d="M220 176H348V184C348 201.673 333.673 216 316 216H252C234.327 216 220 201.673 220 184V176Z"
        fill="#23221F"
      />
      <path
        d="M100 208H144V268C144 279.046 135.046 288 124 288H120C108.954 288 100 279.046 100 268V208Z"
        fill="#23221F"
      />
      <rect x="64" y="160" width="128" height="40" rx="18" fill="#23221F" />
      <rect x="52" y="112" width="152" height="40" rx="18" fill="#23221F" />
    </svg>
  );
};
